module.exports = __webpack_public_path__ + "static/img/logo-pl5.4432766d.png";